<template>
  <v-menu
    left
    offset-y
  >
    <template #activator="{ on: menu, attrs }">
      <v-tooltip bottom>
        <template #activator="{ on: tooltip }">
          <v-btn
            color="red"
            :disabled="!canBeClosed"
            icon
            :loading="isLoading"
            small
            v-bind="attrs"
            v-on="{ ...tooltip, ...menu }"
          >
            <v-icon small>
              mdi-close-circle-outline
            </v-icon>
          </v-btn>
        </template>
        Close Quick Interview
      </v-tooltip>
    </template>
    <v-card>
      <v-card-text>
        Are you sure you want to<br>
        close this Quick Interview?
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="red"
          dark
          depressed
          @click="_ => closeInterview()"
        >
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { alertHandler } from '@/alertHandler'
import { parseErrorResponse } from '@/utilities/error-responses'

import { QUICK_INTERVIEW_NAMESPACE } from '@/store/quick-interview'

export default {
  name: 'CloseQuickInterviewIconButton',

  props: {
    interviewId: {
      type: Number,
      required: true,
    },
  },

  setup () {
    return {
      ...alertHandler(),
    }
  },

  data () {
    return {
      isLoading: false,
    }
  },

  computed: {
    canBeClosed () {
      return ['S', 'R'].includes(this.quickInterview.status)
    },

    quickInterview () {
      return this.quickInterviewsList.find(qi => qi.id === this.interviewId)
    },

    ...mapGetters(QUICK_INTERVIEW_NAMESPACE, [
      'quickInterviewsList',
    ]),
  },

  methods: {
    closeInterview () {
      this.isLoading = true

      this.closeQuickInterview(this.quickInterview.id).
        then(_ => { this.displayAlert('success', 'Interview closed successfully') }).
        catch(e => this.displayAlert('error', parseErrorResponse(e))).
        finally(_ => { this.isLoading = false })
    },

    ...mapActions(QUICK_INTERVIEW_NAMESPACE, [
      'closeQuickInterview',
    ]),
  },
}
</script>
